/**
 * WHICH OF THE MEMBER'S PRACTICES IS ACTIVE - the whole rule, one pure function.
 *
 * Its own module so the domain can be pinned as a table
 * (tests/lib/resolve-active-practice.test.ts) and so the architecture gate has
 * exactly one file to exempt. See active-practice.tsx for how it is wired.
 *
 * `chosenPracticeId` is validated against the CURRENT list rather than trusted: a
 * member can be removed from a practice with the tab still open, and a stale id
 * must fall back rather than leave every screen querying a practice the server
 * will refuse.
 *
 * With no choice yet, prefer a practice whose DPA is accepted - a member of one
 * signed and one unsigned practice lands somewhere they can work.
 *
 * Structural in its input (the two fields it reads) and generic in its output, so
 * it returns the caller's own membership type and needs no import from the API
 * layer - which keeps it loadable by a plain vitest run.
 */
export interface ActivePracticeCandidate {
  readonly practiceId: string;
  readonly dpaAccepted: boolean;
}

export function resolveActivePractice<T extends ActivePracticeCandidate>(
  memberships: readonly T[],
  chosenPracticeId: string | null,
): T | null {
  const chosen =
    chosenPracticeId === null
      ? undefined
      : memberships.find((m) => m.practiceId === chosenPracticeId);
  if (chosen !== undefined) return chosen;
  return memberships.find((m) => m.dpaAccepted) ?? memberships[0] ?? null;
}
